import React, { useCallback } from 'react';
import { Button, Col, Stack, Text } from 'rsuite';

interface PaymentMethodButtonProps {
  icon: string | string[];
  isActive?: boolean;
  name: string;
  onClick: () => void;
}

export const PaymentMethodButton = ({
  icon,
  isActive,
  name,
  onClick,
}: PaymentMethodButtonProps) => {
  const renderIcons = useCallback(() => {
    const iconArr = typeof icon === 'string' ? [icon] : icon;
    return iconArr.map((i) => {
      return (
        <img
          alt={`${name}-${i}-icon`}
          height="12px"
          key={i}
          src={i}
          style={isActive ? { filter: 'brightness(0) invert(1)' } : undefined}
        />
      );
    });
  }, [icon, isActive, name]);

  return (
    <Col
      xs={24}
      md={12}
      className="mb-8"
    >
      <Button
        onClick={onClick}
        aria-pressed={isActive}
        className={
          isActive ? 'btn-primary full-width' : 'btn-secondary full-width'
        }
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          style={{ width: '100%' }}
        >
          <div style={{ display: 'flex', margin: '6px 0 10px', gap: '5px' }}>
            {renderIcons()}
          </div>
          <Text className={`text-small ${isActive ? 'text-white' : ''}`}>
            {name}
          </Text>
        </Stack>
      </Button>
    </Col>
  );
};
